var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    {
      staticClass: "customer-table",
      attrs: {
        border: "",
        fit: "",
        "highlight-current-row": "",
        data: _vm.data,
        size: "small",
      },
    },
    [
      _c("el-table-column", { attrs: { label: "ID", prop: "id" } }),
      _c("el-table-column", { attrs: { label: "型号", prop: "xhname" } }),
      _c("el-table-column", { attrs: { label: "品牌", prop: "source" } }),
      _c("el-table-column", { attrs: { label: "数量", prop: "num" } }),
      _c("el-table-column", { attrs: { label: "单价", prop: "price" } }),
      _c("el-table-column", { attrs: { label: "总价", prop: "zprice" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }